import { useEffect, useCallback } from "react";
import { useNavigate } from 'react-router-dom';

import { refetchData } from "../store/WebSettingsSlice";
import { useAppDispatch } from '.';

const useWindowMessages = () => {

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const onMessage = useCallback(
    (event: any) => {
      const type  = event?.data?.type || null;
      switch (type) {
        case 'redirectWebToHome':
          navigate('/');
          break;
        case 'refetchJson':
          dispatch(refetchData());
          break;
        default:
          break;
      }
    },
    [navigate, dispatch]
  );

  useEffect(() => {
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, [onMessage]);

  return;
};

export default useWindowMessages;
